<script>
import { FormModel } from '@/components/global/form';
import { meta } from 'utils/DOM';
import { scrollToError } from '../../utilities/helpers';

export default {
    name: 'CcFinanceForm',

    props: {
        initialData: null,
    },

    data() {
        return {
            loading: false,
            model: null,
            activeUploadType: 'incorporation',
        };
    },

    created() {
        this.model = new FormModel(this.initialData).transform((data) => {
            data.documents = data.documents.map((document) => ({
                file: document.file,
                type: document.type,
            }));

            return data;
        });

        if (this.model.$.documents) {
            this.model.$.documents.forEach((doc) => {
                if (!doc.type) {
                    doc.type = 'incorporation';
                }
            });
        }

        this.$watch('model.$.register_type', () => {
            this.model.$.documents = [];
        });
    },

    computed: {
        canSubmit() {
            if (!this.model) {
                return false;
            }

            if (this.model.$.documents.some((document) => document.uploading || document.error)) {
                return false;
            }

            return true;
        },
    },

    methods: {
        getDocuments(type) {
            return this.model ?
                this.model.$.documents.filter(d => d.type === type) :
                [];
        },

        addAccount() {
            this.model.$.accounts.push({
                institution: '',
                country: '',
                country_id: null,
            });
        },

        removeAccount(account) {
            this.model.$.accounts = this.model.$.accounts.filter(s => s !== account);
        },

        addTransfer() {
            this.model.$.transfers.push({
                country: '',
                country_id: null,
            });
        },

        removeTransfer(transfer) {
            this.model.$.transfers = this.model.$.transfers.filter(s => s !== transfer);
        },

        documentsChanged(e) {
            if (!e.target.files.length) {
                return;
            }

            Array.from(e.target.files).forEach((file) => {
                this.model.$.documents.push({
                    _file: file,
                    file: null,
                    uploading: false,
                    cancelToken: null,
                    error: null,
                    type: this.activeUploadType,
                });
            });

            e.target.value = '';

            this.uploadFiles();
        },

        addDocuments(type = 'incorporation') {
            this.activeUploadType = type;
            const fileInput = this.$refs.documentSelect;
            fileInput.click();
        },

        removeDocument(document) {
            const index = this.model.$.documents.indexOf(document);
            if (index === -1) {
                return;
            }

            if (document.cancelToken) {
                document.cancelToken.abort();
                document.cancelToken = null;
            }

            this.model.$.documents.splice(index, 1);
        },

        async uploadFiles() {
            for (const entry of this.model.$.documents) {
                if (!entry._file || entry.file || entry.uploading) {
                    continue;
                }

                entry.uploading = true;
                entry.cancelToken = new AbortController();

                const formData = new FormData();
                formData.append('_token', meta('csrf-token'));
                formData.append('file', entry._file);

                fetch('/legal-entity/finance/documents', {
                    method: 'POST',
                    body: formData,
                    signal: entry.cancelToken.signal,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                })
                    .then((response) => {
                        if (response.ok) {
                            return response
                                .json()
                                .then((data) => {
                                    entry.uploading = false;
                                    entry.cancelToken = null;
                                    entry.file = data.data.file;

                                    return data;
                                });
                        }

                        if (response.status === 422) {
                            return response.json()
                                .then((data) => {
                                    entry.error = data.error.errors.file.join(', ');
                                    entry.uploading = false;
                                    entry.cancelToken = null;

                                    return data;
                                });
                        }

                        // Not sure about use cases here, so just report error
                        entry.error = 'Įvyko klaida įkeliant dokumentą';
                        entry.uploading = false;
                        entry.cancelToken = null;

                        return null;
                    })
                    .catch((error) => {
                        if (error.name === 'AbortError') {
                            this.removeDocument(entry);
                            return;
                        }

                        entry.uploading = false;
                        entry.cancelToken = null;

                        this.$sentyReporting.report(error);
                    });
            }
        },

        async submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;

            try {
                const response = await this.$http.post('', this.model.data);
                window.location = response.data.data.redirect;
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);
            }

            this.loading = false;
        },
    },
};
</script>
